import { RouteTreeValue } from "@/lib/renderRouteTree";
import { automationConfigurationUris } from "@/features/automation-configuration/AutomationConfiguration.config";
import { GeneralConfiguration } from "@/features/automation-configuration/GeneralConfiguration";
import { EscalationConfiguration } from "@/features/automation-configuration/EscalationConfiguration";
import { InstallSimulator } from "@/features/automation-configuration/InstallSimulator";
import { AppearanceConfiguration } from "@/features/automation-configuration/AppearanceConfiguration";
import { LayoutConfiguration } from "@/features/automation-configuration/LayoutConfiguration";
import { AutomationConfiguration } from "./AutomationConfiguration";
import { EndOfConversationConfiguration } from "@/features/automation-configuration/EndOfConversationConfiguration";
import { QuackchatSkillsConfiguration } from "@/features/automation-configuration/quackchat-channel/QuackchatSkills";
import { ResourcesConfiguration } from "@/features/automation-configuration/ResourcesConfiguration";
import { SimulatorWrapper } from "../simulators/wrapper";
import { SimulatorWrapper as SimulatorWrapperV2 } from "@/v2/features/simulator/context/SimulatorWrapper";
import { AdvancedConfiguration } from "@/features/automation-configuration/AdvancedConfiguration";
import { PostAnswerActionsConfigurationWrapper } from "@/features/automation-configuration/PostAnswerActionsConfigurationWrapper";
import { KnowledgeHubConfiguration } from "@/features/automation-configuration/knowledge-hub-channel/KnowledgeHubConfiguration";

export const automationConfigurationRouteTree: RouteTreeValue = {
  root: automationConfigurationUris.root,
  rootElement: (
    <SimulatorWrapper>
      <SimulatorWrapperV2>
        <AutomationConfiguration />
      </SimulatorWrapperV2>
    </SimulatorWrapper>
  ),
  tree: [
    {
      path: automationConfigurationUris.general,
      elem: <GeneralConfiguration />,
      index: true,
    },
    {
      path: automationConfigurationUris.end_of_conversation,
      elem: <EndOfConversationConfiguration />,
    },
    {
      path: automationConfigurationUris.escalations,
      elem: <EscalationConfiguration />,
    },
    {
      path: automationConfigurationUris.appearance,
      elem: <AppearanceConfiguration />,
    },
    {
      path: automationConfigurationUris.layout,
      elem: <LayoutConfiguration />,
    },
    { path: automationConfigurationUris.install, elem: <InstallSimulator /> },
    {
      path: automationConfigurationUris.skills,
      elem: <QuackchatSkillsConfiguration />,
    },
    {
      path: automationConfigurationUris.resources,
      elem: <ResourcesConfiguration />,
    },
    {
      path: automationConfigurationUris.advanced,
      elem: <AdvancedConfiguration />,
    },
    {
      path: automationConfigurationUris.post_answer_actions,
      elem: <PostAnswerActionsConfigurationWrapper />,
    },
    {
      path: automationConfigurationUris.knowledge_hub,
      elem: <KnowledgeHubConfiguration />,
    },
  ],
};
